










































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListHaisoArea from '@/components/common/search/ListHaisoArea.vue';
import { API_SEARCH_HAISO_AREA } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlHaisoArea',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListHaisoArea,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '配送エリア',
    },
    widthCd: {
      type: Number,
      default: 99, //32,
    },
    widthName: {
      type: Number,
      default: 170,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_HAISO_AREA,
    listHaisoAreaShow: false,
    haisoAreaCd: 0,
    haisoAreaMei: '',
    haisoAreaComment: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { haisoAreaCd, haisoAreaMei, haisoAreaComment } = item;
      this.haisoAreaCd = haisoAreaCd;
      this.haisoAreaMei = haisoAreaMei;
      this.haisoAreaComment = haisoAreaComment;
      this.listHaisoAreaShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listHaisoAreaShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.haisoAreaCd = value;
      if (value) {
        this.getHaisoAreaItem();
      } else {
        this.haisoAreaMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ haisoAreaCd: this.haisoAreaCd });
      }
    },
    getHaisoAreaItem() {
      axios
        .get(API_SEARCH_HAISO_AREA, {
          params: {
            haisoAreaCd: this.haisoAreaCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.haisoAreaMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ haisoAreaCd: this.haisoAreaCd });
            return;
          }
          this.errors = clearNoDataError();
          const { haisoAreaMei } = res.data.responseData[0];
          this.haisoAreaMei = haisoAreaMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [haisoAreaCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.haisoAreaCd': {
      handler(newValue) {
        if (+newValue === +this.haisoAreaCd) return;
        this.haisoAreaCd = +newValue;
        if (newValue) {
          this.getHaisoAreaItem();
        } else {
          this.haisoAreaMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.haisoAreaCd) {
      this.haisoAreaCd = +this.$attrs.haisoAreaCd;
    }
  },
});
